import script from "./DocumentItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./DocumentItem.vue?vue&type=script&lang=ts&setup=true"

import "./DocumentItem.vue?vue&type=style&index=0&id=73a2b6d5&lang=scss"

const __exports__ = script;

export default __exports__